import avatarBank from './avatarBank.jpg';
import bcpRound from './bcpRound.svg';
import roundIconInProcessing from './roundIconInProcessing.svg';
import warningIcon from './warningIcon.svg';

export const imagesBcp = {
	avatarBank,
	warningIcon,
	roundIconInProcessing,
	bcpRound,
};
